<template>
  <div class="menu_box">
    <el-menu
      ref="menu"
      :default-active="active"
      class="el-menu-vertical-demo"
      background-color="#fff"
      :collapse="!isOpen"
      router
      @select="select"
      :unique-opened="true"
    >
      <template v-for="(item, index) in menus">
        <template v-if="item.children">
          <el-submenu :index="item.path" :key="`menu_${index}`">
            <template slot="title">
              <svg
                :class="['svg', !actives.includes(item.path) ? 'active' : '']"
              >
                <use
                  :href="`#${item.meta.icon}${
                    actives.includes(item.path) ? '_' : ''
                  }`"
                />
              </svg>
              <span
                :class="[
                  'label',
                  actives.includes(item.path) ? 'label_active' : '',
                ]"
                >{{ item.meta.name }}</span
              >
            </template>
            <template v-for="(item1, index1) in item.children">
              <template v-if="item1.children">
                <el-submenu
                  :index="item1.path"
                  :key="`menu_${index}_${index1}`"
                >
                  <template slot="title">{{ item1.meta.name }}</template>
                  <el-menu-item
                    v-for="(item2, index2) in item1.children"
                    :index="item2.path"
                    :key="`menu_${index}_${index1}_${index2}`"
                  >
                    {{ item2.meta.name }}
                  </el-menu-item>
                </el-submenu>
              </template>
              <template v-else>
                <el-menu-item-group :key="`menu_${index}_${index1}`">
                  <el-menu-item :index="item1.path">
                    <span slot="title">{{ item1.meta.name }}</span>
                  </el-menu-item>
                </el-menu-item-group>
              </template>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :index="item.path" :key="`menu_${index}`">
            <svg :class="['svg', !actives.includes(item.path) ? 'active' : '']">
              <use
                :href="`#${item.meta.icon}${
                  actives.includes(item.path) ? '_' : ''
                }`"
              />
            </svg>
            <span
              :class="[
                'label',
                actives.includes(item.path) ? 'label_active' : '',
              ]"
              slot="title"
              >{{ item.meta.name }}</span
            >
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
export default {
  props: ["isOpen"],
  data() {
    return {
      menus: [],
      active: "",
      actives: [],
    };
  },
  methods: {
    init() {
      try {
        const { menusActive, menusActives } = this.$store.state.menusStore;
        function handleChildren(arr) {
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].meta.inMenu == false) {
              arr.splice(i, 1);
              i--;
              continue;
            }
            if (arr[i].children) handleChildren(arr[i].children);
          }
        }
        const _menus = cloneDeep(this.$router.options.routes[2].children || []);
        handleChildren(_menus);
        this.menus = _menus;
        this.active = menusActive
          ? menusActive
          : _menus.length > 0
          ? _menus[0].path
          : "";
        this.actives = menusActives.length ? menusActives : [_menus[0].path];
      } catch (err) {}
    },
    select(path, actives) {
      this.active = path;
      this.actives = actives;
      this.$store.commit("setMenusActive", this.active);
      this.$store.commit("setMenusActives", this.actives);
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.menu_box {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: $layout_margin 0;
  overflow: overlay;
  background: url("~@/assets/image/bgImg/menu_bottom.png") no-repeat left bottom;
  background-size: 100% auto;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}

.svg {
  width: 24px;
  height: 15px;
  padding-bottom: 2px;
  &.active {
    opacity: 0.6;
  }
}
.label_active {
  color: $active_color;
}
.label {
  margin-left: 14px;
}
::v-deep {
  .el-menu--collapse {
    width: 100%;
  }
  .el-menu {
    border-right: 0;
  }
  .el-menu-item,
  .el-submenu__title {
    color: $default_color;
    &.is-active {
      color: $active_color;
      background: transparent !important;
    }
  }
  .el-submenu__title,
  .el-menu-item {
    font-size: 16px;
    &:not(.is-active) {
      background: transparent !important;
    }
  }
  .el-menu-item-group__title {
    padding: 0;
  }
}
</style>
